import { useEffect } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import '../styles/cookieConsent.css';
import { CookieConsent, cookieConsentConfig } from '../lib/cookieConsent';

export function CookieConsentBanner() {
  useEffect(() => {
    CookieConsent.run(cookieConsentConfig);
  }, []);

  return null;
}
